// src/sections/CentralSection.jsx
import React, { useCallback, useState } from "react";
import DateBar from "../components/DateBar/DateBar";
import MatchDay from "../components/MatchDay/MatchDay";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// Mantiene la fecha interna en formato ISO para evitar inconsistencias entre DateBar y MatchDay.
dayjs.extend(utc);
dayjs.extend(timezone);

const CentralSection = () => {
  const [selectedDate, setSelectedDate] = useState(
    dayjs().tz("America/Lima").format("YYYY-MM-DD")
  );

  const handleDateChange = useCallback((date) => {
    setSelectedDate(date);
  }, []);

  return (
    <div className="container mx-auto mt-12 px-3 sm:px-4 lg:px-0">
      <DateBar selectedDate={selectedDate} onDateChange={handleDateChange} />
      <MatchDay selectedDate={selectedDate} onDateChange={handleDateChange} />
    </div>
  );
};

export default CentralSection;
